import {Breadcrumbs, CircularProgress, Grid, Typography} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import HomeIcon from "@mui/icons-material/Home";
import PageTitle from "../../../common/PageTitle";
import {CloudRefreshIcon, DocumentationIcon, DocumentIcon} from "../../../common/Icons";
import CardOption from "../../../common/CardOption";
import {useEffect, useState} from "react";
import {useCommonItems} from "../../../../contexts/CommonItensProvider";
import {useAppContext} from "../../../../contexts/AppContext";


export function Documentation() {
    useEffect(() => {
        return () => {
            sessionStorage.removeItem('docsReloaded');
        };
    }, []);

    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                    <Typography variant='span'>Gerenciamento admin</Typography>
                    <Typography variant='span'>Documentação</Typography>
                </Breadcrumbs>

                <PageTitle icon={<DocumentIcon />} title='Documentação' />
                <Typography mt={2}>Explore a documentação completa para entender todas as funcionalidades e integrações do sistema</Typography>
            </Grid>

            {/* Cards */}
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} mt={4}>
                <CardOption
                    title="Equipamento"
                    description="Documentação das rotas utilizadas nas máquinas."
                    url='equipment'
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} mt={4}>
                <CardOption
                    title="Balcão"
                    description="Documentação das rotas utilizadas nos balcões físicos."
                    url='balcao'
                />
            </Grid>
        </Grid>
    );
}